























































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import Service from "@/services/AuditKeslingService";
import AuditKeslingForm from "./AuditKeslingForm.vue";
import UnitRuangPicker, { UnitRuangOption } from "@/components/common/UnitRuangPicker.vue";

@Component({
  components: { AuditKeslingForm, UnitRuangPicker }
})
export default class AuditKeslingList extends Vue {
  mode: "list" | "create" | "form" = "list";
  currentSessionId = 0;

  sessions: any[] = [];
  loading = false;
  creating = false;

  filterTglDari = "";
  filterTglSampai = "";
  filterStatus: string | null = null;
  filterKategori: string | null = null;

  form: any = {
    unit_id: "",
    unit_nama: "",
    tanggal_audit: "",
    auditor_nama: "",
    auditor_jabatan: "",
    petugas_jaga_nama: "",
    petugas_jaga_jabatan: ""
  };

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "TTD Auditor", value: "submitted" },
    { text: "TTD Petugas Jaga", value: "acknowledged" }
  ];

  kategoriOptions = [
    { text: "Baik (≥85%)", value: "baik" },
    { text: "Cukup (70–84%)", value: "cukup" },
    { text: "Kurang (<70%)", value: "kurang" }
  ];

  headers = [
    { text: "Nomor", value: "nomor_formulir" },
    { text: "Tanggal", value: "tanggal_audit" },
    { text: "Unit", value: "unit_nama" },
    { text: "% Patuh", value: "persen_kepatuhan" },
    { text: "Kategori", value: "kategori_kepatuhan" },
    { text: "Status", value: "status" },
    { text: "", value: "actions", sortable: false, width: 100 }
  ];

  get canCreate(): boolean {
    return !!(this.form.unit_id && this.form.tanggal_audit);
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const params: any = {};
      if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
      if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
      if (this.filterStatus) params.status = this.filterStatus;
      if (this.filterKategori) params.kategori_kepatuhan = this.filterKategori;
      const res = await Service.getList({ params });
      this.sessions = res.data.data.data || res.data.data;
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.mode = "create";
    this.form.tanggal_audit = localISODate();
  }

  onUnitChange(unit: UnitRuangOption | null) {
    this.form.unit_nama = unit ? unit.nama : "";
  }

  async createSession() {
    if (!this.canCreate) return;
    this.creating = true;
    try {
      const res = await Service.create(this.form);
      const sess = res.data.data;
      this.currentSessionId = sess.id;
      this.mode = "form";
    } finally {
      this.creating = false;
    }
  }

  openForm(item: any) {
    this.currentSessionId = item.id;
    this.mode = "form";
  }

  async returnToList() {
    this.mode = "list";
    await this.loadData();
  }

  printPdf(id: number) {
    Service.printPdf(id);
  }

  formatDate(s: string) {
    if (!s) return "-";
    const d = new Date(s);
    return d.toLocaleDateString("id-ID");
  }

  getComplianceColor(rate: number) {
    if (!rate && rate !== 0) return "grey";
    if (rate >= 85) return "success";
    if (rate >= 70) return "warning";
    return "error";
  }
}
